import { render, staticRenderFns } from "./arviointiasteikon-taso.vue?vue&type=template&id=81603144&"
import script from "./arviointiasteikon-taso.vue?vue&type=script&lang=ts&"
export * from "./arviointiasteikon-taso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports